import LogoSrc from "@milize/common/assets/images/yoshinani_logo.svg";
import {
  ROUTES_ADMIN,
  WIDTH_SIDEBAR,
} from "@milize/common/constants/routes.constant";
import { FC, memo } from "react";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import useHook, { Props, ReceivedProps } from "./hook";
import MenuItem from "./MenuItem";
import { SidebarWrapper, StyledMenu } from "./styles";
import { ReactComponent as ContractIcon } from "../../../common/assets/images/ic_contract.svg";
import { ReactComponent as OverviewIcon } from "../../../common/assets/images/ic_overview.svg";
import { ReactComponent as UserIcon } from "../../../common/assets/images/ic_users.svg";
import { ReactComponent as FpIcons } from "../../../common/assets/images/ic_fp.svg";
import { ReactComponent as ProfileIcon } from "../../../common/assets/images/ic_profile.svg";
import { ReactComponent as SettingsIcon } from "../../../common/assets/images/ic_setting.svg";
import { ReactComponent as LogoutIcon } from "../../../common/assets/images/ic_logout.svg";
import { ReactComponent as CompanyIcon } from "../../../common/assets/images/ic_company.svg";
import { ReactComponent as PurposeIcon } from "../../../common/assets/images/icon_purpose.svg";

import { MenuProps } from "antd";
import { getItem } from "@milize/common/utils/contract";
type MenuItem = Required<MenuProps>["items"][number];
const SidebarLayout: FC<Props> = ({ onClickMenuItem, appName }) => {
  const { formatMessage: t } = useIntl();
  const location = useLocation();
  const items: MenuItem[] = [
    getItem(
      t({ id: "sidebar.menu.overview" }),
      ROUTES_ADMIN.HOME,
      <OverviewIcon />
    ),
    getItem(t({ id: "sidebar.menu.users" }), ROUTES_ADMIN.USERS, <UserIcon />),
    getItem(t({ id: "sidebar.menu.fps" }), ROUTES_ADMIN.FPS, <FpIcons />),
    getItem(
      t({ id: "sidebar.menu.operators" }),
      ROUTES_ADMIN.OPERATORS,
      <ProfileIcon />
    ),
    getItem(
      t({ id: "sidebar.menu.company" }),
      ROUTES_ADMIN.COMPANIES,
      <CompanyIcon />
    ),
    getItem(
      t({ id: "sidebar.menu.purpose" }),
      ROUTES_ADMIN.CONTRACT_TYPE,
      <PurposeIcon />
    ),
    getItem(
      t({ id: "sidebar.menu.contracts" }),
      ROUTES_ADMIN.CONTRACTS,
      <ContractIcon />
    ),
    getItem(
      t({ id: "sidebar.menu.settings" }),
      ROUTES_ADMIN.SETTINGS,
      <SettingsIcon />
    ),
    getItem(
      t({ id: "sidebar.menu.logout" }),
      ROUTES_ADMIN.LOGOUT,
      <LogoutIcon />
    ),
  ];
  return (
    <SidebarWrapper width={WIDTH_SIDEBAR}>
      <div className="sidebar-brand">
        <a href="/">
          <img src={LogoSrc} alt="logo" />
        </a>
        <h3>{appName}</h3>
      </div>
      <StyledMenu
        onClick={onClickMenuItem}
        items={items}
        selectedKeys={[
          ROUTES_ADMIN.HOME + location.pathname.split(ROUTES_ADMIN.HOME)[1],
        ]}
      ></StyledMenu>
    </SidebarWrapper>
  );
};

const Sidebar: FC<ReceivedProps> = (props) => {
  return <SidebarLayout {...useHook(props)} />;
};

export default memo(Sidebar);
